/** @override King Living: adds Card; ShopTheLook in content collections. */

import gql from 'graphql-tag';

import {BaseAccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/base-accordion.fragment';
import {BaseAccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/base-accordion-panel.fragment';
import {BaseActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/base-action-links.fragment';
import {CardFragment} from '@amblique/contentful/app/contentful/fragments/card/card.fragment';
import {BaseContainerFragment} from '@amblique/contentful/app/contentful/fragments/container/base-container.fragment';
import {BaseEmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/base-embed-panel.fragment';
import {BaseFeatureListFragment} from '@amblique/contentful/app/contentful/fragments/feature-list/base-feature-list.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseMediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/base-media-carousel.fragment';
import {BaseProductTilesFragment} from '@amblique/contentful/app/contentful/fragments/product-tiles/base-product-tiles.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';
import {BaseShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/base-shop-the-look.fragment';
import {BaseTeaserTileFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile/base-teaser-tile.fragment';

export const SectionPanelFragment = gql`
  ${BaseAccordionFragment}
  ${BaseAccordionPanelFragment}
  ${BaseActionLinksFragment}
  ${BaseSectionPanelFragment}
  ${BaseShopTheLookFragment}
  ${CardFragment}
  ${BaseContainerFragment}
  ${BaseEmbedPanelFragment}
  ${BaseFeatureListFragment}
  ${BaseHeroBannerFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseMediaCarouselFragment}
  ${BaseProductTilesFragment}
  ${BaseRichTextBlockFragment}
  ${BaseTeaserTileFragment}

  fragment SectionPanelFragment on SectionPanel {
    ...BaseSectionPanelFragment

    contentCollection {
      items {
        __typename
        ... on Accordion {
          ...BaseAccordionFragment
        }
        ... on AccordionPanel {
          ...BaseAccordionPanelFragment
        }
        ... on ActionLinks {
          ...BaseActionLinksFragment
        }
        ... on Card {
          ...CardFragment
        }
        ... on Container {
          ...BaseContainerFragment
        }
        ... on EmbedPanel {
          ...BaseEmbedPanelFragment
        }
        ... on FeatureList {
          ...BaseFeatureListFragment
        }
        ... on HeroBanner {
          ...BaseHeroBannerFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on Link {
          ...BaseLinkFragment
        }
        ... on MediaCarousel {
          ...BaseMediaCarouselFragment
        }
        ... on ProductTiles {
          ...BaseProductTilesFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on ShopTheLook {
          ...BaseShopTheLookFragment
        }
        ... on TeaserTile {
          ...BaseTeaserTileFragment
        }
      }
    }
    contentCursorCollection {
      items {
        __typename
        ... on Accordion {
          ...BaseAccordionFragment
        }
        ... on AccordionPanel {
          ...BaseAccordionPanelFragment
        }
        ... on ActionLinks {
          ...BaseActionLinksFragment
        }
        ... on Card {
          ...CardFragment
        }
        ... on Container {
          ...BaseContainerFragment
        }
        ... on EmbedPanel {
          ...BaseEmbedPanelFragment
        }
        ... on FeatureList {
          ...BaseFeatureListFragment
        }
        ... on HeroBanner {
          ...BaseHeroBannerFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on Link {
          ...BaseLinkFragment
        }
        ... on MediaCarousel {
          ...BaseMediaCarouselFragment
        }
        ... on ProductTiles {
          ...BaseProductTilesFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on ShopTheLook {
          ...BaseShopTheLookFragment
        }
        ... on TeaserTile {
          ...BaseTeaserTileFragment
        }
      }
    }
  }
`;
